// Google Ads Conversion Tracking Helper
export const trackConversion = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, {
      'send_to': 'AW-18052744638',
      ...eventParams
    });
    console.log(`[Google Ads] Event tracked: ${eventName}`, eventParams);
  }
};

// Contact Form Conversion - Dispara evento de conversión específico
export const trackContactFormConversion = (formData) => {
  return new Promise((resolve) => {
    if (typeof window !== 'undefined' && window.gtag) {
      // Dispara el evento de conversión para formulario de contacto
      // ID: AW-18052744638, Label: U4OTCPX2kZccEL6LnKBD
      window.gtag('event', 'conversion', {
        'send_to': 'AW-18052744638/U4OTCPX2kZccEL6LnKBD',
        'event_callback': () => {
          console.log('[Google Ads] Contact form conversion tracked');
          resolve(true);
        }
      });
      // Timeout de seguridad por si el callback no se dispara
      setTimeout(() => resolve(true), 1000);
    } else {
      resolve(true);
    }
  });
};

// WhatsApp Conversion - Dispara evento y luego abre WhatsApp
export const trackWhatsAppConversion = (whatsappUrl, source = 'unknown') => {
  return new Promise((resolve) => {
    if (typeof window !== 'undefined' && window.gtag) {
      // Dispara el evento de conversión específico de WhatsApp
      // Label actualizado: KH8CCPiyspgcEL6LnKBD (8 Abr 2026)
      window.gtag('event', 'conversion', {
        'send_to': 'AW-18052744638/KH8CCPiyspgcEL6LnKBD',
        'event_callback': () => {
          console.log(`[Google Ads] WhatsApp conversion tracked from: ${source}`);
          resolve();
        }
      });
      // Timeout de seguridad por si el callback no se dispara
      setTimeout(resolve, 1000);
    } else {
      resolve();
    }
  }).then(() => {
    // Abre WhatsApp después de que se dispare el evento
    window.open(whatsappUrl, '_blank');
  });
};

// Legacy function for backwards compatibility
export const trackWhatsAppClick = (source) => {
  trackConversion('whatsapp_click', {
    'event_category': 'Engagement',
    'event_label': source,
    'value': 1
  });
};

// Specific conversion events
export const trackContactFormSubmit = (formData) => {
  trackConversion('contact_form_submit', {
    'event_category': 'Lead',
    'event_label': formData.company || 'Sin empresa',
    'value': 1
  });
};

export const trackSimulationFormSubmit = (formData) => {
  trackConversion('simulation_form_submit', {
    'event_category': 'Lead',
    'event_label': formData.projectType || 'Sin tipo',
    'value': 1,
    'project_name': formData.projectName,
    'budget': formData.budget
  });
};

// Simulation Form Conversion - Enviar formulario de clientes potenciales
export const trackSimulationFormConversion = (formData) => {
  return new Promise((resolve) => {
    if (typeof window !== 'undefined' && window.gtag) {
      // Dispara el evento de conversión para formulario de simulación
      // ID: AW-18052744638, Label: h04ECJykNJccEL6LnKBD
      window.gtag('event', 'conversion', {
        'send_to': 'AW-18052744638/h04ECJykNJccEL6LnKBD',
        'event_callback': () => {
          console.log('[Google Ads] Simulation form conversion tracked');
          resolve(true);
        }
      });
      // Timeout de seguridad por si el callback no se dispara
      setTimeout(() => resolve(true), 1000);
    } else {
      resolve(true);
    }
  });
};
